import { Radio } from "lucide-react";

const BALL_STYLE = {
  "0": "bg-slate-800 text-slate-400 border-slate-700",
  "1": "bg-slate-700/60 text-slate-200 border-slate-600",
  "2": "bg-slate-700/60 text-slate-200 border-slate-600",
  "3": "bg-slate-700/60 text-slate-200 border-slate-600",
  "4": "bg-amber-500/20 text-amber-300 border-amber-500/40",
  "6": "bg-purple-500/20 text-purple-300 border-purple-500/40",
  "W": "bg-rose-500/25 text-rose-300 border-rose-500/40",
  "Wd": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  "Nb": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
};

export default function BallByBallFeed({ ballLog }) {
  return (
    <div className="tile p-6 grain">
      <div className="flex items-center gap-2 mb-4">
        <Radio className="w-4 h-4 text-emerald-400" />
        <div className="section-label">Ball feed · session</div>
        <span className="text-xs text-slate-500 ml-auto font-mono-data">{ballLog.length} deliveries</span>
      </div>
      {ballLog.length === 0 ? (
        <div className="text-slate-400 text-sm py-6 text-center border border-dashed border-white/10 rounded-lg">
          Trigger the simulator to see deliveries stream here.
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {ballLog.map((b, i) => (
            <div key={i} className={`ball-chip ${BALL_STYLE[b.label] || "bg-slate-800"}`} title={b.label}>
              {b.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
